import React, { useEffect, useState, useMemo } from "react";
import { db } from "../firebase";
import { collection, onSnapshot } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

// --- YARDIMCI FONKSİYONLAR ---
function formatCurrency(n) {
  if (typeof n !== "number") return "0,00 ₺";
  return n.toLocaleString("tr-TR", {
    style: "currency",
    currency: "TRY",
  });
}

function formatDate(dateObj) {
    if (!dateObj) return "";
    return dateObj.toLocaleDateString("tr-TR");
}

export default function PatronRaporlama() {
  const navigate = useNavigate(); // Yönlendirme kancası

  // --- VERİ STATE'LERİ ---
  const [tumTaksitler, setTumTaksitler] = useState([]); // Gelirler (Taksitler)
  const [tumGiderler, setTumGiderler] = useState([]);   // Giderler (Ödemeler)
  const [musteriler, setMusteriler] = useState([]);

  // --- TARİH FİLTRE STATE'LERİ ---
  const [baslangicTarihi, setBaslangicTarihi] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]
  );
  const [bitisTarihi, setBitisTarihi] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split('T')[0]
  );

  const [now, setNow] = useState(new Date());

  // --- SAAT GÜNCELLEME ---
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  // --- VERİ ÇEKME ---
  useEffect(() => {
    const unsub1 = onSnapshot(collection(db, "taksitler"), (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setTumTaksitler(arr);
    });

    const unsub2 = onSnapshot(collection(db, "odemeler"), (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setTumGiderler(arr);
    });

    const unsub3 = onSnapshot(collection(db, "cariler"), (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setMusteriler(arr);
    });

    return () => { unsub1(); unsub2(); unsub3(); };
  }, []);

  // --- TARİH KISAYOL FONKSİYONLARI ---
  const setDateRange = (rangeType) => {
    const bugun = new Date();
    let bas = new Date();
    let bit = new Date();

    if (rangeType === "buAy") {
        bas = new Date(bugun.getFullYear(), bugun.getMonth(), 1);
        bit = new Date(bugun.getFullYear(), bugun.getMonth() + 1, 0);
    } else if (rangeType === "gecenAy") {
        bas = new Date(bugun.getFullYear(), bugun.getMonth() - 1, 1);
        bit = new Date(bugun.getFullYear(), bugun.getMonth(), 0);
    } else if (rangeType === "buYil") {
        bas = new Date(bugun.getFullYear(), 0, 1);
        bit = new Date(bugun.getFullYear(), 11, 31);
    } else if (rangeType === "tumZamanlar") {
        bas = new Date("2020-01-01"); 
        bit = new Date("2030-12-31"); 
    }

    setBaslangicTarihi(bas.toISOString().split('T')[0]);
    setBitisTarihi(bit.toISOString().split('T')[0]);
  };

  // --- FİLTRELEME MOTORU ---
  const raporVerileri = useMemo(() => {
    const start = new Date(baslangicTarihi);
    start.setHours(0,0,0,0);
    const end = new Date(bitisTarihi);
    end.setHours(23,59,59,999);

    // 1. GELİRLERİ FİLTRELE 
    const filtreliGelirler = tumTaksitler.filter(t => {
        if (t.durum !== "Ödendi") return false;
        const islemTarihi = t.odemeTarihi ? t.odemeTarihi.toDate() : t.odemeGunu.toDate();
        return islemTarihi >= start && islemTarihi <= end;
    }).sort((a, b) => (b.odemeTarihi?.toDate() || 0) - (a.odemeTarihi?.toDate() || 0)); 

    // 2. GİDERLERİ FİLTRELE
    const filtreliGiderler = tumGiderler.filter(g => {
        const islemTarihi = g.odemeTarihi ? g.odemeTarihi.toDate() : new Date();
        return islemTarihi >= start && islemTarihi <= end;
    }).sort((a, b) => b.odemeTarihi.toDate() - a.odemeTarihi.toDate());

    // 3. TOPLAMLARI HESAPLA
    const toplamGelir = filtreliGelirler.reduce((acc, curr) => acc + curr.miktar, 0);
    const toplamGider = filtreliGiderler.reduce((acc, curr) => acc + curr.miktar, 0);
    const netKasa = toplamGelir - toplamGider;

    return {
        filtreliGelirler,
        filtreliGiderler,
        toplamGelir,
        toplamGider,
        netKasa
    };
  }, [tumTaksitler, tumGiderler, baslangicTarihi, bitisTarihi]);


  // --- EXCEL AKTAR (İsim Düzeltildi) ---
  const handleExcelExport = () => {
    const wb = XLSX.utils.book_new();

    // Özet Sayfası
    const wsOzet = XLSX.utils.aoa_to_sheet([
        ["ARAS ASAF İNŞAAT - FİNANSAL RAPOR"],
        ["Tarih Aralığı", `${formatDate(new Date(baslangicTarihi))} - ${formatDate(new Date(bitisTarihi))}`],
        [],
        ["TOPLAM GELİR", raporVerileri.toplamGelir],
        ["TOPLAM GİDER", raporVerileri.toplamGider],
        ["NET DURUM (KÂR/ZARAR)", raporVerileri.netKasa]
    ]);
    XLSX.utils.book_append_sheet(wb, wsOzet, "Özet");

    // Gelir Detayları
    const gelirData = [
        ["Tarih", "Müşteri", "Açıklama", "Tutar"],
        ...raporVerileri.filtreliGelirler.map(g => [
            formatDate(g.odemeTarihi?.toDate() || g.odemeGunu.toDate()),
            g.cariAd,
            "Taksit Tahsilatı",
            g.miktar
        ])
    ];
    const wsGelir = XLSX.utils.aoa_to_sheet(gelirData);
    XLSX.utils.book_append_sheet(wb, wsGelir, "Gelir Detayları");

    // Gider Detayları
    const giderData = [
        ["Tarih", "Firma/Şahıs", "Durum", "Tutar"],
        ...raporVerileri.filtreliGiderler.map(g => [
            formatDate(g.odemeTarihi.toDate()),
            g.firmaSahis,
            g.durum,
            g.miktar
        ])
    ];
    const wsGider = XLSX.utils.aoa_to_sheet(giderData);
    XLSX.utils.book_append_sheet(wb, wsGider, "Gider Detayları");

    XLSX.writeFile(wb, `Finans_Raporu_${baslangicTarihi}_${bitisTarihi}.xlsx`);
  };

  // --- PDF AKTAR (İsim Düzeltildi) ---
  const handlePdfExport = () => {
    const doc = new jsPDF();
    
    doc.setFontSize(18);
    doc.text("ARAS ASAF İNŞAAT - FİNANSAL RAPOR", 14, 20);
    
    doc.setFontSize(11);
    doc.text(`Tarih Aralığı: ${formatDate(new Date(baslangicTarihi))} - ${formatDate(new Date(bitisTarihi))}`, 14, 28);
    doc.text(`Rapor Oluşturma: ${now.toLocaleString('tr-TR')}`, 14, 34);

    // Özet Tablosu
    autoTable(doc, {
        startY: 40,
        head: [['Özet Başlığı', 'Tutar']],
        body: [
            ['Seçili Dönem Geliri', formatCurrency(raporVerileri.toplamGelir)],
            ['Seçili Dönem Gideri', formatCurrency(raporVerileri.toplamGider)],
            ['NET KASA', formatCurrency(raporVerileri.netKasa)]
        ],
        theme: 'grid',
        headStyles: { fillColor: [212, 175, 55] } // Altın Rengi
    });

    // Gelirler
    let finalY = doc.lastAutoTable.finalY + 15;
    doc.text("GELİR DETAYLARI (TAHSİLATLAR)", 14, finalY);
    autoTable(doc, {
        startY: finalY + 5,
        head: [['Tarih', 'Müşteri', 'Tutar']],
        body: raporVerileri.filtreliGelirler.map(g => [
            formatDate(g.odemeTarihi?.toDate() || g.odemeGunu.toDate()),
            g.cariAd,
            formatCurrency(g.miktar)
        ]),
        headStyles: { fillColor: [40, 167, 69] } // Yeşil
    });

    // Giderler
    finalY = doc.lastAutoTable.finalY + 15;
    // Sayfa sonuna geldiyse yeni sayfa
    if (finalY > 250) { doc.addPage(); finalY = 20; }
    
    doc.text("GİDER DETAYLARI (ÖDEMELER)", 14, finalY);
    autoTable(doc, {
        startY: finalY + 5,
        head: [['Tarih', 'Kime', 'Durum', 'Tutar']],
        body: raporVerileri.filtreliGiderler.map(g => [
            formatDate(g.odemeTarihi.toDate()),
            g.firmaSahis,
            g.durum,
            formatCurrency(g.miktar)
        ]),
        headStyles: { fillColor: [220, 53, 69] } // Kırmızı
    });

    doc.save(`Finans_Raporu_${baslangicTarihi}.pdf`);
  };

  return (
    <div className="admin-page">
      
      <div className="admin-header">
        {/* --- GÜNCELLEME: Tıklanabilir Logo --- */}
        <h1 
          className="brand-logo admin-brand-header"
          onClick={() => navigate('/patron/dashboard')}
          style={{ cursor: 'pointer' }}
          title="Panele Dön"
        >
          <img src="/logo.png" width="50" alt="" />
          ARAS ASAF İNŞAAT – DETAYLI RAPORLAMA
        </h1>
        
        <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
             <div className="date-time-info">
                {now.toLocaleDateString("tr-TR")} | {now.toLocaleTimeString("tr-TR")}
            </div>
            <Link to="/patron/dashboard" className="admin-button-secondary small">
            ← Patron Paneli
            </Link>
        </div>
      </div>

      {/* --- FİLTRELEME ALANI --- */}
      <div className="form-section" style={{borderLeft: '5px solid #d4af37'}}>
        <h3 style={{fontSize: '1.1rem', marginBottom: '15px', color: '#555'}}>Tarih Aralığı Seçimi</h3>
        
        <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'flex-end'}}>
            <div className="form-group">
                <label>Başlangıç</label>
                <input 
                    type="date" 
                    value={baslangicTarihi} 
                    onChange={(e) => setBaslangicTarihi(e.target.value)} 
                    style={{padding: '8px', borderRadius: '5px', border: '1px solid #ccc'}}
                />
            </div>
            <div className="form-group">
                <label>Bitiş</label>
                <input 
                    type="date" 
                    value={bitisTarihi} 
                    onChange={(e) => setBitisTarihi(e.target.value)} 
                    style={{padding: '8px', borderRadius: '5px', border: '1px solid #ccc'}}
                />
            </div>

            {/* KISAYOL BUTONLARI */}
            <div style={{display: 'flex', gap: '10px'}}>
                <button onClick={() => setDateRange("buAy")} className="admin-button-secondary small">Bu Ay</button>
                <button onClick={() => setDateRange("gecenAy")} className="admin-button-secondary small">Geçen Ay</button>
                <button onClick={() => setDateRange("buYil")} className="admin-button-secondary small">Bu Yıl</button>
                <button onClick={() => setDateRange("tumZamanlar")} className="admin-button-secondary small">Tüm Zamanlar</button>
            </div>

            {/* ÇIKTI BUTONLARI */}
            <div style={{marginLeft: 'auto', display: 'flex', gap: '10px'}}>
                <button onClick={handleExcelExport} className="admin-button small" style={{backgroundColor: '#217346'}}>📗 Excel İndir</button>
                <button onClick={handlePdfExport} className="admin-button small" style={{backgroundColor: '#b30b00'}}>📕 PDF İndir</button>
            </div>
        </div>
      </div>

      {/* --- ÖZET KARTLAR --- */}
      <div className="summary-card-grid" style={{marginTop: '20px'}}>
        <div className="summary-card gelir">
          <h3 className="card-title">SEÇİLİ TARİH GELİRİ</h3>
          <p className="card-amount">{formatCurrency(raporVerileri.toplamGelir)}</p>
          <span className="card-status" style={{color:'#28a745'}}>Tahsil Edilen</span>
        </div>

        <div className="summary-card gider">
          <h3 className="card-title">SEÇİLİ TARİH GİDERİ</h3>
          <p className="card-amount">{formatCurrency(raporVerileri.toplamGider)}</p>
          <span className="card-status" style={{color:'#dc3545'}}>Yapılan Ödeme</span>
        </div>

        <div className={`summary-card ${raporVerileri.netKasa >= 0 ? 'gelir' : 'gider'}`}>
          <h3 className="card-title">NET KASA DURUMU</h3>
          <p className="card-amount">{formatCurrency(raporVerileri.netKasa)}</p>
          <span className="card-status">Kâr / Zarar</span>
        </div>

        <div className="summary-card beklenen">
          <h3 className="card-title">TOPLAM MÜŞTERİ</h3>
          <p className="card-amount">{musteriler.length}</p>
          <span className="card-status">Kayıtlı Cari</span>
        </div>
      </div>

      {/* --- DETAY TABLOLARI (YAN YANA) --- */}
      <div className="patron-layout-grid" style={{marginTop: '30px'}}>
        
        {/* SOL: GELİR LİSTESİ */}
        <div className="admin-table-container" style={{marginTop:0}}>
            <h3 style={{color: '#28a745', borderBottom: '2px solid #28a745', paddingBottom: '10px'}}>
                💰 Gelir Hareketleri ({raporVerileri.filtreliGelirler.length})
            </h3>
            <div style={{maxHeight: '400px', overflowY: 'auto'}}>
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Tarih</th>
                            <th>Kimden</th>
                            <th>Tutar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {raporVerileri.filtreliGelirler.length === 0 ? (
                            <tr><td colSpan="3" style={{textAlign:'center', color:'#999'}}>Bu tarih aralığında tahsilat yok.</td></tr>
                        ) : (
                            raporVerileri.filtreliGelirler.map(g => (
                                <tr key={g.id}>
                                    <td>{formatDate(g.odemeTarihi?.toDate() || g.odemeGunu.toDate())}</td>
                                    <td>{g.cariAd}</td>
                                    <td style={{color: '#28a745', fontWeight:'bold'}}>{formatCurrency(g.miktar)}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>

        {/* SAĞ: GİDER LİSTESİ */}
        <div className="admin-table-container" style={{marginTop:0}}>
             <h3 style={{color: '#dc3545', borderBottom: '2px solid #dc3545', paddingBottom: '10px'}}>
                💸 Gider Hareketleri ({raporVerileri.filtreliGiderler.length})
            </h3>
            <div style={{maxHeight: '400px', overflowY: 'auto'}}>
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Tarih</th>
                            <th>Kime</th>
                            <th>Durum</th>
                            <th>Tutar</th>
                        </tr>
                    </thead>
                    <tbody>
                    {raporVerileri.filtreliGiderler.length === 0 ? (
                            <tr><td colSpan="4" style={{textAlign:'center', color:'#999'}}>Bu tarih aralığında gider yok.</td></tr>
                        ) : (
                            raporVerileri.filtreliGiderler.map(g => (
                                <tr key={g.id}>
                                    <td>{formatDate(g.odemeTarihi.toDate())}</td>
                                    <td>{g.firmaSahis}</td>
                                    <td><span style={{fontSize:'0.8rem', padding:'2px 6px', borderRadius:'4px', backgroundColor: g.durum === 'Ödendi' ? '#d4edda' : '#fff3cd'}}>{g.durum}</span></td>
                                    <td style={{color: '#dc3545', fontWeight:'bold'}}>{formatCurrency(g.miktar)}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>

      </div>

    </div>
  );
}